import $ from 'jquery';

import Component from '../Component';

export default class AgeChecker extends Component {
    STORAGE_KEY = 'wetheme-age-check';

    constructor(theme, element) {
      super(theme, element);

      this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
      this.ageDelay = 0;
      this.ageTestMode = this.element.dataset.ageTestMode === 'true';

      this.load();
    }

    load = () => {

      function trapFocus() {
        setTimeout(function(){ 
          if(document.querySelector('.verification-popup-container')){
            var inputs = $('.verification-popup-container').find('button, a').filter(':visible');
            var firstInput = inputs.first();
            var lastInput = inputs.last();

            /*set focus on first input*/
            $('.verification-popup-container').focus();

            /*redirect last tab to first input*/
            lastInput.on('keydown', function (e) {
              if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstInput.focus();
              }
            });

            /*redirect first shift+tab to last input*/
            firstInput.on('keydown', function (e) {
              if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastInput.focus();
              }
            });
          } 
        }, 1000);
      }

      if (this.ageTestMode) {
        // age checker is in test mode - will show immediately in editor and on live site
        $('.verification-popup-container').css('display', 'block');
        trapFocus();
      }

      const enterButton = document.getElementById('button__enter');
      const exitButton = document.getElementById('button__exit');
      const returnButton = document.getElementById('button__return');
      const closeButton = document.querySelector('.verification-popup__close-button');
      const modalLinks = document.querySelector('.modal-content__wrapper a');

      if(modalLinks) {
        modalLinks.setAttribute("tabindex", "1");
      }

      function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        } 
        return null;
      }

      var isAnAdult = readCookie('isAnAdult');
      if (!isAnAdult) {
        $('.verification-popup-container').css('display', 'block');
        trapFocus();
      } 

      if (enterButton) {
        enterButton.addEventListener('click', function(){
          document.write("<style> #prompt__background { display: none; }</style>");
          document.cookie = "isAnAdult=true; expires=0; path=/";
          location.reload();
        });
      }

      if (exitButton) {
        exitButton.addEventListener('click', function(){
          $('#verification__prompt').scrollTop(0);
          $('.verification-popup__close-button').css('display', 'block');
          const changeContent = document.querySelector('.modal-deny-content');
          const hideInitial = document.querySelector('.modal-initial-content');
          changeContent.classList.remove('hidden');
          hideInitial.classList.add('hidden');
          trapFocus();
        });
      }
      
      if (returnButton) {
        returnButton.addEventListener('click', function(){
          $('#verification__prompt').scrollTop(0);
          $('.verification-popup__close-button').css('display', 'none');
          const changeContent = document.querySelector('.modal-deny-content');
          const hideInitial = document.querySelector('.modal-initial-content');
          changeContent.classList.add('hidden');
          hideInitial.classList.remove('hidden');
          trapFocus();
        });
      }

      if(closeButton) {
        closeButton.addEventListener('click', function(){
          $('#verification__prompt').scrollTop(0);
          $('.verification-popup__close-button').css('display', 'none');
          const changeContent = document.querySelector('.modal-deny-content');
          const hideInitial = document.querySelector('.modal-initial-content');
          changeContent.classList.add('hidden');
          hideInitial.classList.remove('hidden');
          trapFocus();
        });
      }
    }
}
